import React, { Component } from 'react'
import Layout from 'antd/lib/layout'
const { Content } = Layout
class App extends Component {
  state = {
    viewType: window.location.pathname.split('/')[1].toUpperCase() === '' ? 'KID' : window.location.pathname.split('/')[1].toUpperCase(),
    isPurchase: false,
    module: null
  }
  componentDidMount() {
    // console.log(this.state.viewType)
    // console.log(window.location.pathname)
    const path = this.state.viewType === 'GOV' ? './view/Official' : this.state.viewType === 'KID' ? './view/Kiddy' :  './view/Admission'
    // console.log(path)
    import(`${path}`).then(module => this.setState({ 
      module: module.default 
    }))
  }

  handleViewTypeChange = viewType => {
    console.log(viewType)
    window.localStorage.setItem('viewType', viewType)
    if(viewType === 'GOV'){
      window.location.href = '/gov'
    }else if(viewType === 'KID'){
      window.location.href = '/kid'
    }else{
      window.location.href = '/admission'
    }
    this.setState({ viewType })
  }

  handleHidePaymentModal = () => {
    this.setState({ isPurchase: false })
  }

  handleShowPaymentModal = () => {
    this.setState({ isPurchase: true })
  }


  render() {
    const { module: Component } = this.state
    return (
      <Layout style={{ background: 'transparent' }}>
      <Content style={{ backgroundColor: 'transparent' }}>
        {
          Component && <Component switchBrand={this.handleViewTypeChange.bind(this)} />
        }
      </Content>
    </Layout>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.jsx